// extracted by mini-css-extract-plugin
export default {"container":"NoSearchResults_container__AN6nJ","backGround":"NoSearchResults_backGround__f1Nli"};